import { useEffect } from "react";
import { LoopOnce } from "three";

const AnimationToggle = ({ action, delay = 500, timeScale = 1, ...props }) => {
  useEffect(() => {
    var timeout = setTimeout(() => {
      action.time = 0;
      action.timeScale = timeScale;
      action.clampWhenFinished = true;
      action.loop = LoopOnce;
      action.reset().play().fadeIn(0.5);
      action.play();
    }, [delay]);

    return () => {
      if (timeout) {
        clearTimeout(timeout);
      }
      action.timeScale = -1;
      action.play().fadeOut(1.0);
      // action.time = 0;
      // action.fadeOut(5.0).stop().reset();
    };
  }, []);

  return null;
};

export default AnimationToggle;
